<template>
    <div v-if="active" class="event-tab">
        <div class="wrapper">
            <table v-if="extras.length > 0" class="table clean narrow">
                <thead>
                    <tr>
                        <th>Extras</th>
                        <th class="text-right">Booked</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="eventComponent in extras">
                        <td>{{extraName(eventComponent)}}</td>
                        <td class="text-right">{{ eventComponent.quantityBooked }}</td>
                    </tr>
                </tbody>
            </table>

            <div v-else class="dark text-center m-3">
                No booked extras
            </div>

        </div>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: {
            active: false,
            event: Object
        },
        computed: {
            extras: function() {
                return this.event.eventComponents.filter(extra => {return extra.quantityBooked > 0});
            },
            totalPax: function() {
                let totalPax = 0;

                return totalPax;
            },
            totalCheckin: function() {
                let totalCheckin = 0;

                return totalCheckin;
            },
            totalNoshow: function() {
                let totalNoshow = 0;

                return totalNoshow;
            },
            totalCancellation: function() {
                let totalCancellation = 0;

                return totalCancellation;
            },
            totalMissing: function() {
                let n = (this.totalPax - this.totalCheckin);

                return (n >= 0) ? n : 0;
            },
        },
        methods: {
            extraName: function(eventComponent){
                return (eventComponent.component.name) + (eventComponent.componentPrice? ' - '+eventComponent.componentPrice.name : '');
            }
        },
        components: {
        }
    }
</script>



// WEBPACK FOOTER //
// EventExtras.vue?34382995